module.exports = __webpack_public_path__ + "img/emojione_smiling-face-with-smiling-eyes.4aac9b00.svg";